export function elementToValue(e: React.ChangeEvent<HTMLSelectElement>) {
  //valueは ●点 or ●名 の文字列で入っているため、末尾の「名もしくは点」を取り除く
  return Number(e.target.value.replace(/名|点$/, ''))
}
if (import.meta.vitest) {
  const { it, expect } = import.meta.vitest
  it('elementToValue', () => {
    const e = { target: { value: '1名' } } as React.ChangeEvent<HTMLSelectElement>
    expect(elementToValue(e)).toBe(1)

    const e2 = { target: { value: '2点' } } as React.ChangeEvent<HTMLSelectElement>
    expect(elementToValue(e2)).toBe(2)
  })
}
